<!--<div class="card card-box mb-5">-->
<!--  <div class="card-header py-3">-->
<!--    <div class="card-header&#45;&#45;title font-size-lg">-->
<!--      <b><i class="fas fa-cog"></i> Transport </b>-->
<!--    </div>-->
<!--    <div class="card-header&#45;&#45;actions">-->
<!--      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="addModal(lgModal)">-->
<!--                      <span class="btn-wrapper&#45;&#45;icon">-->
<!--                          <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
<!--                      </span>-->
<!--        <span class="btn-wrapper&#45;&#45;label">-->
<!--                          New Transport-->
<!--                      </span>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-between px-4 py-3">-->
<!--    <div class="search-wrapper">-->
<!--          <span class="icon-wrapper text-black">-->
<!--            <fa-icon [icon]="['fas', 'search']"></fa-icon>-->
<!--          </span>-->
<!--      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="divider"></div>-->
<!--  <div class="table-responsive">-->
<!--    <table class="table table-hover text-nowrap mb-0">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        &lt;!&ndash;        <th class="bg-white text-center">ID</th>&ndash;&gt;-->
<!--        <th class="bg-white text-center">ID</th>-->
<!--        <th class="bg-white text-center">NAME</th>-->
<!--        <th class="bg-white text-center">DISCRIPTION</th>-->
<!--        <th class="bg-white text-center">VIEW</th>-->
<!--        <th class="bg-white text-center">ACTIONS</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr *ngFor="let gal of trans">-->
<!--        &lt;!&ndash;        <td class="font-weight-bold text-center">&ndash;&gt;-->
<!--        &lt;!&ndash;         {{pac.id}}&ndash;&gt;-->
<!--        &lt;!&ndash;        </td>&ndash;&gt;-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{gal.id}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{gal.name}}-->
<!--        </td>-->
<!--        <td class="text-center">-->
<!--          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">-->
<!--            {{gal.description}}-->
<!--          </span>-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--            <button  type="button" class="btn btn-warning" (click)="view(viewModal,gal.id)">-->
<!--              <i class="fas fa-eye"></i>-->
<!--            </button>-->
<!--          </div>-->
<!--        </td>-->

<!--        <td class="text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--                        <button type="button" class="btn btn-warning" (click)="update(gal)"><i class="fas fa-upload"></i></button>-->
<!--            <button type="button" class="btn btn-danger" (click)="openModal(errorModal,gal.id)" ><i class="fas fa-times-circle"></i></button>-->

<!--          </div>-->
<!--        </td>-->
<!--      </tr>-->

<!--      </tbody>-->
<!--    </table>-->


<!--  </div>-->
<!--  <div class="card-footer py-3 d-flex justify-content-between">-->

<!--  </div>-->
<!--</div>-->



<ng-template #errorModal>
  <div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
      <div class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
      </div>
    </div>
    <h4 class="font-weight-bold mt-4">Are you sure you want to CANCEL this entry?</h4>
    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>
    <div class="pt-4">
      <button (click)="declineCancel()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
                <span class="btn-wrapper--label">
                    Cancel
                </span>
      </button>
      <button (click)="confirmCancel()" class="btn btn-pill btn-danger mx-1" type="button">
                <span class="btn-wrapper--label">
                    Delete
                </span>
      </button>
    </div>
  </div>
</ng-template>



<div bsModal #lgModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Create/Update</h6>
        <button type="button" class="close" (click)="lgModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-3"></div>
          <div class="col-6">
            <form [formGroup]="transForm">
              <input formControlName="name" class="form-control mb-2 " placeholder="Name" type="text">
              <textarea formControlName="description" class="form-control mb-2 " placeholder="Description" type="text"></textarea>
            </form>

          </div>
          <div class="col-3"></div>
          <div class="col-3"></div>
          <div class="col-6">
            <ngx-dropzone (change)="onSelect($event)">
              <ngx-dropzone-label>Drop!</ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
          </div>
          </div>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="lgModal.hide()">Close</button>
        <button *ngIf="isupdate!=true" type="button" class="btn btn-success ml-auto ladda-button"  data-style="slide-up"
                [ladda]="isLoading" (click)="createTrasport()">Save changes</button>

        <button *ngIf='isupdate==true' type="button" class="btn btn-warning ml-auto ladda-button"  data-style="slide-up"
                [ladda]="isLoading" (click)="updateTransport()">Update changes</button>
      </div>
    </div>
  </div>
</div>


<!--<div bsModal #viewModal="bs-modal" class="modal fade" tabindex="-1"-->
<!--     role="dialog" aria-labelledby="dialog-sizes-name1">-->
<!--  <div class="modal-dialog modal-dialog-centered modal-lg">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h6 class="modal-title">View</h6>-->
<!--        <button type="button" class="close" (click)="viewModal.hide()" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <div class="modal-body">-->

<!--        <img style="width: 100%" src="data:image/png;base64,{{img}}" alt="">-->

<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-link btn-link-dark" (click)="viewModal.hide()">Close</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->



<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-10">
        <h4><b>Transport</b></h4>
        <p class="text-muted">Below are the transport details</p>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-success" (click)="addModal(lgModal)"> Create new</button>
      </div>
    </div>
    <hr>

    <div class="row">
      <div class="col-12 mb-3" *ngFor="let pac of trans">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <img class="img" src="{{pac.url}}" alt="">
              </div>
              <div class="col-7">
                <h5 class="mt-3"><b>{{pac.name}}</b></h5>
                <p>{{pac.description}}</p>
              </div>
              <div class="col-2">
                <div class="mb-2">
                  <button class="btn btn-warning btn-sm" style="width: 89px" (click)="update(pac)">Update</button>
                </div>
                <div>
                  <button (click)="openModal(errorModal,pac.id)" class="btn btn-danger btn-sm" style="width: 89px;">Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>














<notifier-container></notifier-container>
